import React from 'react';
import { useAuth } from '../context/AuthContext';
import Icon from './AppIcon';
import Button from './ui/Button';

const CertificateModal = ({ certificate, onClose }) => {
  const { user } = useAuth();

  // Ensure we have a name to display
  const recipientName = certificate?.userName || user?.name || 'Volunteer';

  if (!certificate) return null;

  const handlePrint = () => {
    // Open a new window for printing specifically
    const printWindow = window.open('', '', 'width=800,height=600');
    const today = new Date().toLocaleDateString();

    printWindow.document.write(`
      <html>
        <head>
          <title>Certificate - ${certificate.title}</title>
          <style>
            body { font-family: 'Georgia', serif; text-align: center; padding: 50px; background: #f9f9f9; }
            .certificate { border: 10px solid #444; padding: 50px; background: white; max-width: 800px; margin: auto; position: relative; }
            .header { font-size: 40px; color: #333; margin-bottom: 20px; text-transform: uppercase; letter-spacing: 2px; }
            .sub-header { font-size: 18px; color: #666; margin-bottom: 30px; }
            .name { font-size: 48px; color: #1a56db; font-family: 'Cursive', serif; margin: 10px 0 20px; border-bottom: 2px solid #ddd; display: inline-block; padding-bottom: 1px; }
            .connector { font-size: 16px; color: #555; margin: 20px 0 10px; font-style: italic; }
            .event-title { font-size: 36px; font-weight: bold; color: #222; margin: 10px 0 30px; text-transform: uppercase; letter-spacing: 1px; }
            .body { font-size: 18px; line-height: 1.6; color: #555; margin-bottom: 40px; }
            .footer { display: flex; justify-content: space-between; margin-top: 50px; }
            .signature { border-top: 1px solid #333; width: 200px; padding-top: 10px; }
            @media print {
              body { background: white; padding: 0; }
              .certificate { border: 5px solid #444; box-shadow: none; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="certificate">
            <div class="header">Certificate of Achievement</div>
            <div class="sub-header">PROUDLY PRESENTED TO</div>
            <div class="name">${recipientName}</div>
            
            <div class="connector">For successfully completing the program:</div>
            <div class="event-title">${certificate.title}</div>
            
            <div class="body">
              This certificate acknowledges the dedication and commitment shown on<br/>
              <strong>${today}</strong>
            </div>
            
            <div class="footer">
              <div class="signature">
                <p>VolunteerConnect Director</p>
              </div>
              <div class="signature">
                <p>VolunteerConnect</p>
              </div>
            </div>
          </div>
          <script>
            window.onload = function() { window.print(); window.close(); }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-xl font-bold text-gray-900">Certificate View</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-8 bg-gray-50 overflow-y-auto max-h-[70vh] flex justify-center">
          {/* Visual Representation in Modal */}
          <div className="bg-white border-8 border-double border-gray-700 p-12 text-center shadow-md max-w-2xl w-full bg-[url('https://www.transparenttextures.com/patterns/cream-paper.png')]">
            <div className="flex justify-center mb-4">
              <Icon name="Award" size={56} className="text-yellow-500" />
            </div>

            <h1 className="text-4xl font-serif font-bold text-gray-800 uppercase tracking-widest mb-2">Certificate</h1>
            <p className="text-gray-500 uppercase tracking-wider text-sm mb-6">Of Achievement</p>

            <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-2">Proudly Presented To</p>
            <h2 className="text-5xl font-serif text-blue-800 mb-6 italic border-b-2 border-gray-200 inline-block pb-2 px-8">{recipientName}</h2>

            <p className="text-lg text-gray-600 italic mb-2">For successfully completing the program:</p>
            <h3 className="text-3xl font-bold text-gray-900 mb-8 uppercase tracking-wide">{certificate.title}</h3>

            <p className="text-gray-600 mb-8">
              Acknowledged for dedication and service on <strong>{new Date().toLocaleDateString()}</strong>
            </p>

            <div className="flex justify-between items-end mt-12 px-8">
              <div className="text-center">
                <div className="text-sm font-bold text-gray-800 border-t border-gray-400 pt-2 w-32 mx-auto">{new Date().toLocaleDateString()}</div>
                <p className="text-xs text-gray-500 mt-1">Date</p>
              </div>
              <div className="text-center">
                <div className="text-sm font-bold text-gray-800 border-t border-gray-400 pt-2 w-48 mx-auto">VolunteerConnect</div>
                <p className="text-xs text-gray-500 mt-1">Issuer</p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 border-t bg-gray-50 flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>Close</Button>
          <Button variant="default" iconName="Download" onClick={handlePrint}>Download / Print</Button>
        </div>
      </div>
    </div>
  );
};

export default CertificateModal;
